module.exports = __webpack_public_path__ + "static/media/Projects.425470a0.svg";